import { useSessionStorage } from 'react-use';
import SwitchToYearlyModal from '@/components/Modals/SwitchToYearly/modal';
import { useAnnualDiscountPercentage } from '@/hooks/billing/useAnnualDiscountPercentage';
import { useOverduePayment } from '@/hooks/billing/useOverduePayment';
import { useReferrals } from '@/providers/ReferralsProvider';
import { useMemo } from 'react';
import { X } from '@music-vine/cadence/icons';
const SwitchToAnnual = () => {
  const [show, setShow] = useSessionStorage('switch-to-annual-button', true);
  const {
    isFreeUserOnPaidTrial,
    isLoading
  } = useReferrals();
  const {
    overduePayment
  } = useOverduePayment();
  const templateFn = (percentage: number) => `Save up to ${percentage}%`;
  const {
    annualDiscountInUpgradePill,
    showNewAnnualDiscount
  } = useAnnualDiscountPercentage(templateFn);
  const buttonStyle = useMemo(() => ({
    flexWrap: showNewAnnualDiscount ? 'wrap' as const : 'nowrap' as const
  }), [showNewAnnualDiscount]);
  const widthStyle = useMemo(() => ({
    width: '112px'
  }), []);
  if (!show || isFreeUserOnPaidTrial || isLoading || overduePayment) {
    return null;
  }
  return <SwitchToYearlyModal data-sentry-element="SwitchToYearlyModal" data-sentry-component="SwitchToAnnual" data-sentry-source-file="index.tsx">
      <div className="group relative w-full shrink-0 bg-green-50 px-6 py-4 text-white transition focus-within:bg-green-dark hover:bg-green-100 dark:bg-green-950 dark:hover:bg-green-900 dark:focus-within:bg-green-900">
        <div className="relative flex w-full items-start justify-between gap-3">
          <button className="flex flex-col items-start justify-between gap-2 focus-visible:underline" style={buttonStyle} type="button">
            <span className="cursor-pointer font-semibold text-gray-950 text-xs xl:text-sm dark:text-white">
              Switch to yearly
            </span>
            <span className="slide-in-from-top-0.5 relative flex h-7 w-[112px] cursor-pointer items-center overflow-hidden rounded-lg bg-green-600 font-semibold text-xs leading-6 transition group-hover:bg-green-600 dark:bg-green-500 dark:group-hover:bg-green-500" style={widthStyle}>
              <span className="absolute block w-full whitespace-nowrap text-center transition-transform duration-250 group-hover:translate-y-full" style={widthStyle}>
                {annualDiscountInUpgradePill}
              </span>
              <span className="absolute block w-full -translate-y-full whitespace-nowrap text-center transition-transform duration-250 group-hover:translate-y-0" style={widthStyle}>
                Upgrade
              </span>
            </span>
          </button>

          <button className="-mx-3 -my-1 cursor-pointer [:focus-visible&>svg]:ring-2 [:focus-visible&>svg]:ring-white [:focus-visible&>svg]:ring-offset-2 [:focus-visible&>svg]:ring-offset-green-dark dark:[:focus-visible&>svg]:ring-offset-green-900" onClick={e => {
          e.preventDefault();
          setShow(false);
        }} type="button">
            <X className="size-5 rounded-full text-gray-950 transition dark:text-white" data-sentry-element="X" data-sentry-source-file="index.tsx" />
          </button>
        </div>
      </div>
    </SwitchToYearlyModal>;
};
export default SwitchToAnnual;